export const navigateToLogin = (path: string) => {
  const loginUrl = `/.auth/login/aadb2c?post_login_redirect_uri=${encodeURIComponent(path)}`
  if (!import.meta.dev) {
    // Use direct browser redirect to avoid Nuxt router trying to resolve the route first
    // which causes a brief 404 flash before redirect
    if (import.meta.client) {
      if (window.self !== window.top) {
        // inside iframe → open new tab
        window.open(loginUrl, '_blank', 'noopener,noreferrer')
      } else {
        // normal → same tab redirect
        window.location.assign(loginUrl)
      }
      return
    }
    // For SSR, use navigateTo as fallback
    return navigateTo(loginUrl, {
      external: true,
    })
  }
}

export const navigateToLogout = (path?: string) => {
  const base = '/.auth/logout'
  const url = path ? `${base}?post_logout_redirect_uri=${encodeURIComponent(path)}` : base
  // Use direct browser redirect to avoid Nuxt router trying to resolve the route first
  if (import.meta.client) {
    window.location.href = url
    return
  }
  return navigateTo(url, { external: true })
}
